/**
 * The "Get Heidi on mobile" modal's analytics vocabulary: the `screen_name` token
 * it reports against, the payload its one event carries, and the emit seam the app
 * binds.
 *
 * WHAT IS HERE AND WHAT IS NOT. The token and the payload are contract — two
 * spellings of `get_heidi_mobile` is two screens. The EMIT is not, and neither is
 * the event NAME: this lands as `modal_viewed`, one of the app's cross-domain
 * generic events, which forty call sites across nine domains report. No single
 * domain owns it, so no domain declares it (D9 ruling 27) — a second declarer is
 * a `duplicate-event-name` collision in `buildAppRegistry`. That is why there is
 * no descriptor for it in `src/contributions/analytics.ts`; what growth owns of
 * it is the token below.
 *
 * The app-side host maps the token to the `ScreenName` enum member that declares
 * it and asserts the two agree, rather than letting a package token and an app
 * enum drift into two spellings of one row.
 */

/** The one screen this surface reports against. */
export const MOBILE_APP_DOWNLOAD_SCREEN = {
  getHeidiMobile: 'get_heidi_mobile',
} as const;

export type MobileAppDownloadScreenToken =
  (typeof MOBILE_APP_DOWNLOAD_SCREEN)[keyof typeof MOBILE_APP_DOWNLOAD_SCREEN];

/** `modal_viewed` — the download modal became visible. */
export type MobileAppDownloadModalViewedProps = {
  screen_name: MobileAppDownloadScreenToken;
};

/**
 * The emit seam for the modal being shown.
 *
 * Fired from the open-state effect on the domain side, which is where the
 * open→closed→open decision lives; the app adds the event name and the routing.
 */
export type TrackMobileAppDownloadModalViewed = (
  props: MobileAppDownloadModalViewedProps
) => void;
